import { defineComponent as i, createElementBlock as p, openBlock as l, mergeProps as u, unref as o, createBlock as f, createCommentVNode as c, createVNode as d, resolveDynamicComponent as _, normalizeClass as b, withCtx as r, renderSlot as t, createTextVNode as $, toDisplayString as y } from "vue";
import n from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Menu/menu.js";
import C from "../../helpers/AutoWrap.vue2.js";
import g from "./MenuList.vue2.js";
import k from "./MenuItem.vue2.js";
import { useOUIAProps as B } from "../../helpers/ouia.js";
const V = /* @__PURE__ */ i({
  name: "PfMenuGroup",
  __name: "MenuGroup",
  props: {
    label: {},
    titleId: {},
    labelHeadingLevel: { default: "h1" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(s) {
    const a = s, m = B({ id: a.ouiaId, safe: a.ouiaSafe });
    return (e, G) => (l(), p("section", u(o(m), {
      class: o(n).menuGroup
    }), [
      e.label || e.$slots.label ? (l(), f(_(e.labelHeadingLevel), {
        key: 0,
        class: b(o(n).menuGroupTitle)
      }, {
        default: r(() => [
          t(e.$slots, "label", {}, () => [
            $(y(e.label), 1)
          ])
        ]),
        _: 3
      }, 8, ["class"])) : c("", !0),
      d(C, {
        component: g,
        include: k
      }, {
        default: r(() => [
          t(e.$slots, "default")
        ]),
        _: 3
      })
    ], 16));
  }
});
export {
  V as default
};
